import { DiagramDefinition } from "../types";

export const m022Definition: DiagramDefinition = {
  id: "M-022",
  title: "Solarch AI Agent SDK Runtime Architecture",
  description:
    "Architectural diagram of the Solarch AI Agent SDK showing the public @solarch/agents interface, Solarch Runtime Layer with AgentExecutor, BudgetController, and OutputGuard, the DeepAgentAdapter boundary, deepagents kernel, native tool registry via @solarch/core-client, and backend Solarch server.",
  viewBox: "0 0 800 490",
  nodes: [
    // Tier 1: Public Surface
    {
      id: "PublicAPI",
      kind: "client",
      label: "@solarch/agents",
      subtext: "Agent & Workflow Public API",
      position: [400, 50],
      size: [240, 50],
    },

    // Tier 2: Runtime Engine & Safety Gates
    {
      id: "RuntimeLayer",
      kind: "service",
      label: "Solarch Runtime Engine",
      subtext: "AgentExecutor & Task Lifecycle",
      position: [240, 150],
      size: [210, 50],
    },
    {
      id: "SafetyGate",
      kind: "service",
      label: "Safety & Output Guard",
      subtext: "BudgetController & Secret Redaction",
      position: [560, 150],
      size: [220, 50],
    },

    // Tier 3: Adapter Boundary
    {
      id: "AdapterBoundary",
      kind: "service",
      label: "DeepAgentAdapter Boundary",
      subtext: "Type & Cancellation Encapsulation",
      position: [400, 250],
      size: [250, 50],
    },

    // Tier 4: Execution Engine Kernel
    {
      id: "Engine",
      kind: "service",
      label: "deepagents@1.13.0",
      subtext: "Execution Graph Kernel",
      position: [400, 345],
      size: [210, 48],
    },

    // Tier 5: Tools & Backend Storage
    {
      id: "CoreClient",
      kind: "service",
      label: "Native Tools Registry",
      subtext: "10 Tools via @solarch/core-client",
      position: [240, 435],
      size: [220, 50],
    },
    {
      id: "Backend",
      kind: "database",
      label: "Solarch Server",
      subtext: "SQLite WAL & Server ACLs",
      position: [560, 435],
      size: [220, 50],
    },
  ],
  edges: [
    {
      id: "e1",
      source: "PublicAPI",
      target: "RuntimeLayer",
      sourcePort: "bottom",
      targetPort: "top",
      routing: "orthogonal",
      animated: true,
    },
    {
      id: "e2",
      source: "PublicAPI",
      target: "SafetyGate",
      sourcePort: "bottom",
      targetPort: "top",
      routing: "orthogonal",
    },
    {
      id: "e3",
      source: "RuntimeLayer",
      target: "AdapterBoundary",
      sourcePort: "bottom",
      targetPort: "top",
      routing: "orthogonal",
    },
    {
      id: "e4",
      source: "SafetyGate",
      target: "AdapterBoundary",
      sourcePort: "bottom",
      targetPort: "top",
      routing: "orthogonal",
    },
    {
      id: "e5",
      source: "AdapterBoundary",
      target: "Engine",
      sourcePort: "bottom",
      targetPort: "top",
      routing: "straight",
      animated: true,
    },
    {
      id: "e6",
      source: "Engine",
      target: "CoreClient",
      sourcePort: "bottom",
      targetPort: "top",
      routing: "orthogonal",
    },
    {
      id: "e7",
      source: "CoreClient",
      target: "Backend",
      sourcePort: "right",
      targetPort: "left",
      routing: "straight",
      label: "Secure API",
      animated: true,
    },
  ],
};
